// language=GraphQL
export const ALL_BRANDINGS_QUERY = `query Query($withLogo: Boolean = false) {
  brandings: travelPricingBrandings {
    id
    logo @include(if: $withLogo) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    logoWidth
  }
}`

// language=GraphQL
export const SINGLE_BRANDING_QUERY = `query Query($id: ID!, $withLogo: Boolean = false) {
  branding: travelPricingBranding(id: $id) {
    id
    logo @include(if: $withLogo) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    logoWidth
  }
}`

// language=GraphQL
export const CREATE_BRANDING_MUTATION = `
  mutation Mutation($input: CreateTravelPricingBrandingInput, $withLogo: Boolean = false) {
    branding: createTravelPricingBranding(input: $input) {
      id
      logo @include(if: $withLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
    }
  }`

// language=GraphQL
export const UPDATE_BRANDING_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingBrandingInput, $withLogo: Boolean = false) {
    branding: updateTravelPricingBranding(input: $input) {
      id
      logo @include(if: $withLogo) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      logoWidth
    }
  }`

// language=GraphQL
export const DELETE_BRANDING_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingBrandingInput) {
    deleteTravelPricingBranding(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BRANDING_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingBrandingInput) {
    forceDeleteTravelPricingBranding(input: $input) {
      success
    }
  }`
// language=GraphQL
export const BRANDINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricings: Boolean = false) {
  groupedDependents: travelPricingBrandingDependents(id: $id) {
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
  }
}`
